export const PrintPdfHeader = ({title, organisationName, organisationLogo, children }) => {
    return (
        <>
        <div className="print-only-header mb-4">
            <div className="print-only-header-top">
                <div className="d-flex">
                    { organisationLogo && <img src={ organisationLogo } alt={`${organisationName} Logo`} className="print-only-logo" /> }
                </div>
                <div className="print-only-header-text">
                    <div className="d-flex">
                        <h1 className="print-only-org-name">{ organisationName }</h1>
                    </div>
                    <h3 className="print-only-title">{title}</h3>
                    <span className="print-only-generated">Generated { new Date().toLocaleDateString("en-GB") }</span>
                </div>
            </div>
            <div className="print-only-filters">
                {children}
            </div>
        </div>
        <div className="print-only-footer">
            <img src="/assets/img/apt-logos/logo.svg" alt="APT Logo" className="print-only-footer-logo" />
        </div>
        </>
    )
}
